// extracted by mini-css-extract-plugin
export var promotionLink = "_w2-0";